module.exports = __webpack_public_path__ + "img/ball_0_green.b64edf11.png";